import { useRootStore } from '../RootStateContext';

export const useWindowDimensionsStore = () => {
  const rootStore = useRootStore();

  if (!rootStore?.windowDimensionsStore) {
    throw new Error('window dimensions store should be defined');
  }

  return rootStore.windowDimensionsStore;
};
